import "./style.css";

import { tablet } from "../../app/breakpoints";

export default class Guide {
  static selector = ".guide";

  constructor(block) {
    this.block = block;

    this.vw = document.documentElement.clientWidth;

    this.mobileMenuHeaderWrapper = this.block.querySelector(".menu-mobile");
    this.mobileMenuHeader = this.block.querySelector(".menu-mobile__item");
    this.mobileMenuHeaderText = this.block.querySelector(
      ".menu-mobile__item p"
    );

    this.mobileMenuIcon = this.block.querySelector(".menu-mobile__item__icon");

    this.menu = this.block.querySelector(".guide__menu");

    this.items = this.block.querySelectorAll(".guide__menu__item");
    this.details = this.block.querySelectorAll(".guide__report");

    this.items[0].classList.add("selected");

    this.items.forEach((item) => {
      item.addEventListener("click", this.handleClick);
    });

    this.observer = new IntersectionObserver(this.handleObserve, {
      threshold: 0.1,
    });

    // add observer to each report item
    this.details.forEach((detail) => {
      this.observer.observe(detail);
    });

    this.mobileMenuHeader.addEventListener("click", this.handleMobileMenu);
  }

  // handle click on a single menu item
  handleClick = (e) => {
    var el = e.currentTarget;
    const index = el.dataset.itemIndex;

    var text = e.currentTarget.textContent;

    if (this.vw > tablet) {
      // desktop
      this.handleSelected(index);

      // scroll to corresponding report
      this.details.forEach((detail) => {
        if (detail.dataset.reportIndex === index) {
          this.scrollToReport(detail, 107);
        }
      });
    } else {
      // tablet or mobile

      this.menu.classList.add("hide");
      this.mobileMenuIcon.style.transform = "rotate(0deg)";
      this.mobileMenuHeaderWrapper.style.paddingBottom = "2.5rem";

      this.details.forEach((detail) => {
        if (detail.dataset.reportIndex === index) {
          setTimeout(() => {
            this.scrollToReport(detail, 54);
            this.mobileMenuHeaderText.textContent = text;
            this.menu.classList.remove("hide");
            this.menu.style.removeProperty("display");
          }, 500);
        }
      });
    }
  };

  handleObserve = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting === true) {
        const index = entry.target.dataset.reportIndex;
        this.handleSelected(index);
        this.changeMobileTitle(index);
      }
    });
  };

  // toggle selected class while scrolling or when clicking on an item
  handleSelected = (index) => {
    this.items.forEach((item) => {
      if (item.dataset.itemIndex === index) {
        item.classList.add("selected");
      } else {
        item.classList.remove("selected");
      }
    });
  };

  handleMobileMenu = () => {
    // if open close it
    if (this.menu.style.display == "block") {
      this.menu.style.removeProperty('display');
      this.mobileMenuHeaderWrapper.style.paddingBottom = "2.5rem";
      this.mobileMenuIcon.style.transform = "rotate(0deg)";
    } else {
      // if closed open it
      this.menu.style.display = "block";
      this.mobileMenuHeaderWrapper.style.paddingBottom = 0;
      this.mobileMenuIcon.style.transform = "rotate(180deg)";
    }
  };

  changeMobileTitle = (index) => {
    this.mobileMenuHeaderText.textContent = this.items[index].textContent;
  };

  scrollToReport = (element, scrollMargin) => {
    let scrollTop = window.pageYOffset || element.scrollTop;
    const finalOffset =
      element.getBoundingClientRect().top + scrollTop - scrollMargin;

    window.parent.scrollTo({
      top: finalOffset,
      behavior: "smooth" || "auto",
    });
  };
}
